// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"abc6adf3","455":"5e9f90ee","977":"a203ea50"}[chunkId] + ".chunk.js";
};